<template>
  <div class="divider-editor">
    <ul :key="partId" class="editor-design">
      <li>
        罫線スタイル
      </li>
      <!-- 罫線 -->
      <li class="border flex-box">
        <!-- 背景色 -->
        <select-color
          :type="'part'"
          :target="'background'"
          :value="styles['background']"
          :selector="null"
          @updateStyles="updateStyles($event)"
          class="background"
        />
        <select-border
          :kind="'divider'"
          :type="'part'"
          :target="'border'"
          :value="styles['border-top']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 上下余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-top'"
          :value="styles['padding-top']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 左右余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-right'"
          :value="styles['padding-right']"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'parts',
    'sectionId',
    'partsContainerId',
  ],
  computed: {
    partId () {
      return this.parts[0].id
    },
    styles () {
      return this.parts[0].styles
    }
  },
  components: {
    SelectBorder,
    SelectColor,
    Slider,
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updatePartStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        styles: styles
      })
    },
  },
}
</script>

<style lang="scss">
.divider-editor {
  .editor-design {
    .common-select {
      margin: 0;
    }
  }
}
</style>
